import { useBankProfile } from '@contexts/BankProfileContext';
import type { ReactNode } from 'react';
import type { Capability } from 'types/roles';

interface PermissionGateProps {
	capability: Capability;
	children: ReactNode;
	fallback?: ReactNode;
}

export const PermissionGate = ({
	capability,
	children,
	fallback = null,
}: PermissionGateProps) => {
	const { hasCapability, selectedProfile, profilesUnavailable } = useBankProfile();

	// Profile not resolved yet — render nothing rather than treating it as denied.
	if (!selectedProfile && !profilesUnavailable) {
		return null;
	}

	if (!hasCapability(capability)) {
		return fallback;
	}

	return children;
};
